// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F1h_f","title":"styles_title__1tUZ8"};